
//EXTERNAL API
import BanxioSIEAPIService from "./BanxioSIEAPIService";

export const $banxicoSIE = {
    banxico: new BanxioSIEAPIService(),
};